<!--选择excle文件并上传页面-->
<template>
  <div class="page-container">
    <Header></Header>

    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>

      <div class="content">
        <!-- 页面标题 -->
        <div class="page-header">
          <div v-if="form_id" class="page-title">
            <i class="el-icon-document-add"></i>往《{{form_name}}》里导入数据
          </div>
          <div v-else class="page-title">
            <i class="el-icon-upload"></i>智能导入表格
          </div>

          <div class="page-description">
            <p>上传需要核对的Excel格式数据表。<span class="text-danger">如果上传失败，请将文件另存为"Microsoft Excel 97-2003文件(*.xls)"文件后再上传。</span></p>
            <p><span class="text-danger">注意：1.文件不要超过10M；2.数据之间不要有空行。</span></p>
          </div>
        </div>

        <!-- 上传区域 -->
        <div class="upload-container">
          <el-form ref="editForm" :model="editForm">
            <el-form-item>
              <el-upload
                class="upload-area"
                :http-request="uploadFile"
                action
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="fileChange"
                :before-remove="beforeRemove"
                accept=".xls,.xlsx"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList">

                <div class="upload-content">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="如果文件大小超过5M,可能传不上去。减小文件大小的方法是：新建一个excel文件,把旧文件中数据复制粘贴到新文件中保存,新文件会变小。可联系客服免费协助解决."
                    placement="top">
                    <el-button type="primary" class="upload-btn">
                      <i class="el-icon-upload"></i>点击上传Excel文件(Office 2007以上版本文件)
                    </el-button>
                  </el-tooltip>

                  <div class="upload-tip">
                    <p>支持 .xls 和 .xlsx 格式，文件大小不超过10M</p>
                  </div>
                </div>
              </el-upload>

              <!-- 文件列表 -->
             <!-- <div v-if="fileList.length > 0" class="file-list">
                <div class="file-item">
                  <div class="file-info">
                    <i class="el-icon-document"></i>
                    <span class="file-name">{{ fileList[0].name }}</span>
                    <span class="file-size">({{ formatFileSize(fileList[0].size) }})</span>
                  </div>
                  <el-button
                    type="danger"
                    plain
                    size="small"
                    @click="emptyFileList"
                    class="delete-btn">
                    <i class="el-icon-delete"></i>删除文件
                  </el-button>
                </div>
              </div> -->
            </el-form-item>

            <!-- 操作按钮 -->
            <div class="action-area">
              <el-form-item>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="请不要使用IE浏览器.其他浏览器如果点击无反应,把浏览器切换成'高速模式'后重新登录再试试.切换方法见下方帮助."
                  placement="bottom">
                  <el-button
                    type="primary"
                    :disabled="fileList.length === 0"
                    @click="uploadExcelFile"
                    class="next-btn">
                    <i class="el-icon-right"></i>下一步
                  </el-button>
                </el-tooltip>
              </el-form-item>

              <!-- 帮助链接 -->
              <div class="helper-links">
                <el-button
                  @click="howToSwitch"
                  type="text"
                  size="medium"
                  class="helper-link">
                  <i class="el-icon-s-operation"></i>如何将浏览器切换成"高速模式"或"快速模式"
                </el-button>

                <el-button
                  @click="showUse"
                  type="text"
                  size="medium"
                  class="helper-link">
                  <i class="el-icon-reading"></i>查看导入必读
                </el-button>

<!--                <el-link
                  type="danger"
                  href="javascript:window.open('http://wpa.qq.com/msgrd?v=3&uin=34424698&site=qq&menu=yes', '_brank')"
                  target="_blank"
                  class="helper-link">
                  <i class="el-icon-service"></i>点我寻求客服QQ远程支持
                </el-link> -->
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 浏览器模式切换弹窗 -->
    <el-dialog
      width="80%"
      :close-on-click-modal="false"
      title="如何切换浏览器的模式"
      :visible.sync="browserSwitchDialogVisible"
      custom-class="custom-dialog">

      <div class="dialog-content">
        <p>如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"</p>
        <br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        <p>正确的应该是如下图所示：</p>
        <br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 合并单元格检查弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="表格不能有合并的单元格"
      :visible.sync="checkFormDialogVisible"
      custom-class="custom-dialog">

      <div class="dialog-content">
        <p>为了方便核查数据，以及减少导入过程中出错的可能性，请将表格中合并单元格全部取消掉后再导入。</p>
        <p class="dialog-tip">取消所有合并单元格的方法是：选中单元格，点"合并单元"取消合并的单元格，取消后如果有空白单元格请填充好数据，方便后期确认数据。</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="checkFormDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 导入必读弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="表格导入必读"
      :visible.sync="mustReadDialogVisible"
      custom-class="custom-dialog">

      <div class="dialog-content">
        <div class="faq-item">
          <h4><i class="el-icon-question"></i>问：适合导入什么样的表格？</h4>
          <p>答：适合导入首行水平是表头，每行是填表人需要填写数据的表格；如果是复杂表格，请自行设计成首行是表头的表格后再导入。</p>
        </div>

        <div class="faq-item">
          <h4><i class="el-icon-question"></i>问：在什么情况下使用导入表格功能？</h4>
          <p>答：一种情况是您有表格，手机端制作录入麻烦，可以用导入；另外一种情况是需要填表人修改您excel表格里的数据，比如修订已有数据。</p>
        </div>

        <div class="faq-item">
          <h4><i class="el-icon-question"></i>问：在什么情况导入空表？</h4>
          <p>答：需要填表人填表时导入空表。</p>
        </div>

        <div class="faq-item">
          <h4><i class="el-icon-question"></i>问：在什么情况导入数据？</h4>
          <p>答：需要填表人修改您excel表格上的数据时导入数据。</p>
        </div>

        <div class="faq-item">
          <h4><i class="el-icon-question"></i>问：表头特别复杂怎么导入？</h4>
          <p>答：导入表格要观察列，因为一个列是一个数据，所以这个列叫什么就给这个列取什么名字。列名可以在预览界面点击单元格选择，可以减少输入量。</p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mustReadDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 上传失败弹窗 -->
    <el-dialog
      width="60%"
      :close-on-click-modal="false"
      title="上传Excel文件失败"
      :visible.sync="uploadFailDialogVisible"
      custom-class="custom-dialog">

      <div class="dialog-content">
        <p>上传文件失败！请检查Excel文件大小是否超过5M，如果Excel文件大小超过5M且表中的数据又不多，说明Excel文件中存在大量的空行或空列。修复方法是新建一个Excel文件，将原表格中的数据(只选数据，不是全选)粘贴到新Excel文件中保存后重新上传。如果仍然无法解决，请联系客服帮您处理。</p>

        <div class="contact-info">
          <p><i class="el-icon-chat-dot-round"></i>客服微信：<strong>wx34424698</strong></p>
          <p><i class="el-icon-phone"></i>紧急电话：<strong>19909408114</strong></p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadFailDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        },

        checkFormDialogVisible: false,
        mustReadDialogVisible: false,

        form_id: '',
        form_name: '',

        uploadFailDialogVisible: false
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('username', this.username)

        let tmpExcelFile = this.fileList[0].raw

        data.append('file', tmpExcelFile)
        data.append('form_id', this.form_id)
        data.append('form_name', this.form_name)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/checking/web/_upload_data_excel_for_preview.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log('数据导入完成！！')
          load.close()

          // 会话过期时后端返回空响应或"登录已过期"JSON，需提示并返回登录页
          if (!res.data || !res.data.result || (res.data.message && res.data.message.indexOf('登录') >= 0)) {
            that.handleSessionTimeout()
            return
          }
          if (res.data.result == '1') {
            var uploaded_excel_file_name = res.data.excel_file
            that.$router.push({
              name: 'excel_data_preview_ai',
              params: {
                username: that.username,
                excel_file: uploaded_excel_file_name,
                form_id: that.form_id,
                form_name: that.form_name
              }
            })
          } else {
            // result == '-1'：优先展示后端返回的具体失败原因
            if (res.data.message) {
              that.$message.error(res.data.message)
            } else {
              that.uploadFailDialogVisible = true
            }
          }

        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()
          // 服务端未登录保护返回 401/403 时也按会话过期处理
          if (err.response && (err.response.status == 401 || err.response.status == 403)) {
            that.handleSessionTimeout()
          } else {
            that.uploadFailDialogVisible = true
          }
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
        console.log(fileList)
        return true
      },
      back() {
        this.$router.push('/validation_form_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      // 会话过期处理：提示用户并清空本地登录信息后返回登录页
      handleSessionTimeout() {
        this.$message.warning('登录已过期，请重新登录')
        this.$session.set('USERNAME', '')
        this.$session.set('NAME', '')
        this.$router.push('/')
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      showUse() {
        this.mustReadDialogVisible = true
      },

      // 格式化文件大小显示
      formatFileSize(bytes) {
        if (bytes === 0) return '0 B'
        const k = 1024
        const sizes = ['B', 'KB', 'MB', 'GB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
      }

    }
  }
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-layout {
  flex: 1;
  display: flex;
}

.sidebar {
  width: 220px;
  background: #fff;
  border-right: 1px solid #e8ecf1;
  flex-shrink: 0;
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 页面标题 */
.page-header {
  margin-bottom: 30px;
}

.page-title {
  font-size: 22px;
  color: #303133;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.page-title i {
  color: #1485FB;
}

.page-description {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  border-left: 4px solid #1485FB;
}

.page-description p {
  margin: 8px 0;
  color: #555;
  line-height: 1.6;
}

.text-danger {
  color: #f56c6c;
}

/* 上传容器 */
.upload-container {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* 上传区域 */
.upload-area {
  margin-bottom: 20px;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border: 2px dashed #dcdfe6;
  border-radius: 6px;
  background: #fafbfc;
  transition: all 0.3s ease;
}

.upload-content:hover {
  border-color: #1485FB;
  background: #f5f9ff;
}

.upload-btn {
  padding: 12px 24px;
  font-size: 16px;
  margin-bottom: 10px;
}

.upload-btn i {
  margin-right: 8px;
}

.upload-tip {
  color: #909399;
  font-size: 14px;
  margin-top: 8px;
}

/* 文件列表 */
.file-list {
  margin-top: 16px;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-info i {
  color: #1485FB;
  font-size: 18px;
}

.file-name {
  color: #303133;
  font-weight: 500;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  color: #909399;
  font-size: 14px;
}

.delete-btn {
  margin-left: 10px;
}

/* 操作区域 */
.action-area {
  margin-top: 30px;
}

.next-btn {
  padding: 12px 28px;
  font-size: 16px;
}

.next-btn i {
  margin-right: 8px;
}

/* 帮助链接 */
.helper-links {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.helper-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1485FB;
}

.helper-link:hover {
  color: #0066CC;
}

.helper-link i {
  font-size: 14px;
}

/* 弹窗样式 */
::v-deep .custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  padding: 16px 20px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.dialog-content {
  padding: 10px 0;
}

.dialog-tip {
  color: #666;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
  border-left: 3px solid #e6a23c;
}

.faq-item {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8ecf1;
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-item h4 {
  color: #303133;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}

.faq-item h4 i {
  color: #1485FB;
}

.faq-item p {
  color: #555;
  line-height: 1.6;
  margin-left: 26px;
}

.contact-info {
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #1485FB;
}

.contact-info p {
  margin: 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #555;
}

.contact-info strong {
  color: #303133;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .content {
    padding: 16px;
  }

  .page-title {
    font-size: 20px;
  }

  .upload-container {
    padding: 16px;
  }

  .file-name {
    max-width: 200px;
  }

  .helper-links {
    gap: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/import_data_excel_ai.vue